import {ADICIONAR_FILTRO_BAGAGEM} from '../types'

export default function adicionarFiltroBagagem (filtro) {
  return {
    type: ADICIONAR_FILTRO_BAGAGEM,
    payload: filtro
  }
}
